import React from "react";
import { View, Text, Modal, TouchableOpacity, StyleSheet } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";

interface CoinsBalanceInfoPopupProps {
  visible: boolean;
  onClose: () => void;
}

const CoinsBalanceInfoPopup = ({ visible, onClose }) => {
  const styles = useStyles();
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.title}>What are Coins?</Text>
            <TouchableOpacity onPress={onClose}>
              <Text style={styles.closeButton}>✖</Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.text}>
            Coins are the primary currency earned or spent within the platform
            for day-to-day activities.
          </Text>
          <Text style={styles.subheading}>Usage:</Text>
          <Text style={styles.text}>
            <Text style={styles.bold}>Join Events:</Text> Users might need to
            pay coins to participate in tournaments, challenges, or events.
          </Text>
          <Text style={styles.text}>
            <Text style={styles.bold}>Earned Rewards: </Text>Coins can be earned
            through actions like participating in events, completing challenges,
            or leveling up.
          </Text>
          <Text style={styles.text}>
            <Text style={styles.bold}> Small Purchases: </Text>Coins can be used
            for small in-app purchases like event customization, entry fees, or
            consumables.
          </Text>
        </View>
      </View>
    </Modal>
  );
};

export default CoinsBalanceInfoPopup;

const useStyles = CreateResponsiveStyle(
  {
    overlay: {
      flex: 1,
      left: "74%",
      top: "37%",
    },
    container: {
      backgroundColor: "#000",
      padding: 20,
      borderRadius: 10,
      width: "90%",
      maxWidth: 400,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",

      marginBottom: 10,
    },
    title: {
      fontSize: 18,
      fontWeight: "bold",
      color: "#fff",
    },
    closeButton: {
      color: "#fff",
      fontSize: 18,
    },
    text: {
      fontSize: 14,
      color: "#fff",
      marginBottom: 8,
    },
    subheading: {
      fontSize: 16,
      fontWeight: "bold",
      color: "#fff",
      marginTop: 10,
    },
    bold: {
      fontWeight: "bold",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      overlay: {
        left: "8%",
        top: "38%",
      },
      container: {
        padding: 10,
        width: "84%",
      },
    },
    [DEVICE_SIZES.SM]: {
      overlay: {
        left: "26%",
        top: "32%",
      },
      container: {
        padding: 10,
        maxWidth: 367,
      },
    },
    [DEVICE_SIZES.MD]: {
      overlay: {
        left: "26%",
        top: "29%",
      },
      container: {
        padding: 10,
        maxWidth: 367,
      },
    },
    [DEVICE_SIZES.LG]: {
      overlay: {
        left: "26%",
        top: "25%",
      },
      container: {
        padding: 10,
        maxWidth: 485,
      },
    },
  }
);
